import { axios } from "helper/axios";
import { jarvisPrimeRmsConstants } from "./jarvisPrimeRmsConstants";


const jarvisPrimeRmsApis = {};

jarvisPrimeRmsApis.getRMSDetails = () => {
    return axios.get(jarvisPrimeRmsConstants.PRIME_RMS_API);
}



export { jarvisPrimeRmsApis };